var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "3600",
                  reset: true,
                  "expand-adv": true,
                  "show-simple": false,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  advSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.cancelAccrueHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_CancelAccrue")) + " "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "25000623",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "25000624",
                    total: _vm.filter.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toAdvancedQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.showJobDialog.visible
        ? _c("show-history-job-dialog", {
            ref: "showJobDialog",
            attrs: {
              visible: _vm.showJobDialog.visible,
              jobs: _vm.showJobDialog.jobs,
              "rule-configs": _vm.showJobDialog.ruleConfigs
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.showJobDialog, "visible", $event)
              },
              close: function($event) {
                _vm.showJobDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.accrueSelectDialog.visible
        ? _c("accrue-select-dialog", {
            ref: "accrueSelectDialog",
            attrs: { visible: _vm.accrueSelectDialog.visible },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.accrueSelectDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }